/* eslint-disable max-len */
import React from 'react'
import AliceCarousel from 'react-alice-carousel'
import { Text, View, useStyles } from '@ion-ui/core'
import ProductsCard from '../Cards/ProductsCard'
import elnorte from '../../assets/svg/logo_ElNorte.svg'
import lajornadav from '../../assets/svg/logo_LaJornadaVeracruz.svg'
import lajornada from '../../assets/svg/logo_LaJornada.svg'
import milenio from '../../assets/svg/logo_Milenio.svg'
import mural from '../../assets/svg/logo_Mural.svg'
import reforma from '../../assets/svg/logo_Reforma.svg'
import { Styles } from './styles.js'

const words = [{
  title: 'Milenio',
  description: '“En este sentido, el presidente de la Sociedad Financiera Popular (Sofom) ION, José Shabot, aseguró que el tema central será la vivienda, rubro que no depende de la pandemia ni de la crisis, sino del crecimiento demográfico que ha mantenido el país en los últimos 30 años”',
  img: milenio,
  link: 'https://www.milenio.com/negocios/falta-creditos-oportunidad-sofomes-mercado-inmobiliario'
},
{
  title: 'Reforma',
  description: '“Ante el menor financiamiento por parte de la banca comercial a los constructores de vivienda, ION busca atender a este segmento, para el que en 2021 espera aumentar su monto colocado en casi 50 por ciento”',
  img: reforma,
  link: 'https://www.reforma.com/aplicacioneslibre/preacceso/articulo/default.aspx?urlredirect=https://www.reforma.com/buscan-atender-financiamiento-a-vivienda/ar2113174?v=1&referer=--7d616165662f3a3a6262623b726760657a6770737a6778743b767a783a--'
},
{
  title: 'La Jornada',
  description: '“José Shabot Cherem, presidente del Consejo de Administración de ION, una Sofom especializada en dar créditos a la vivienda, consideró que en este momento, este tipo de instituciones toman más riesgos que los bancos tradicionales”',
  img: lajornada,
  link: 'https://www.jornada.com.mx/notas/2021/01/26/economia/buscan-las-sofomes-participar-en-creditos-de-viviendas/'
},
{
  title: 'La Jornada Veracruz',
  description: '“José Shabot añadió que 2021 pinta como un periodo de esperanza y recuperación, donde se retomen los proyectos inmobiliarios que estaban en puerta antes de la pandemia y se generen nuevos que necesiten financiamiento en los próximos años”',
  img: lajornadav,
  link: 'http://jornadaveracruz.com.mx/Post.aspx?id=210127_091338_677'
},
{
  title: 'El Norte',
  description: '“En conferencia, José Shabot Cherem, presidente del consejo de administración de ION Financiera, explicó que para este año se estima colocar un monto de 4 mil 500 millones de pesos para créditos puente, es decir, financiamientos para constru...”',
  img: elnorte,
  link: 'https://www.elnorte.com/aplicacioneslibre/preacceso/articulo/default.aspx?urlredirect=https://www.elnorte.com/buscan-atender-financiamiento-a-vivienda/ar2113186'
},
{
  title: 'Mural',
  description: '“Así, aunado a la meta de otorgamiento de crédito para vivienda, de liquidez y autofinanciamiento, ION espera que sus ingresos anuales aumenten 14 por ciento, mientras que su balance financiero crecería 32 por ciento”',
  img: mural,
  link: 'https://www.mural.com.mx/aplicacioneslibre/preacceso/articulo/default.aspx?urlredirect=https://www.mural.com.mx/buscan-atender-financiamiento-a-vivienda/ar2113187'
}]

const WrittenAboutUs = () => {
  const styles = useStyles(Styles)

  return (
    <View css={styles.mainContent}>
      <Text variant='h4'>Las palabras se las lleva el viento...</Text>
      <Text variant='subtitle' css={styles.subtitle}>Pero lo que han escrito de ION se queda aquí</Text>
      <View css={styles.galleryResize}>
        <AliceCarousel
          responsive={{ 300: { items: 1 }, 767: { items: 2 }, 1059: { items: 3 }, 1400: { items: 4 } }}
          autoWidth={true}
          mouseTracking
          infinite={true}
          autoPlay={true}
          autoPlayInterval={0}
          animationEasingFunction='cubic-bezier(0, 0, 1, 1)'
          animationDuration={8000}
          items={words.map((item, index, array) => {
            return (
              <ProductsCard
                key={index}
                {...item}
                index={index}
                array={array}
                active={true}
                height={'312'}
                width={'312'}
                onlyOneButton={true}
              />
            )
          })}
          controlsStrategy='responsive'
          disableButtonsControls={true}
          disableDotsControls={true}
        />
      </View>
    </View>
  )
}

export default WrittenAboutUs
